export * from './IFaq';
export * from './IFaqLight';
export * from './IFaqSearchParams';
